"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableColumnFormatHintPropertyOption = exports.isResultsTableColumnFormatHintProperty = exports.resultsTableColumnFormatHintPropertyDefinition = void 0;
const resultsTableColumnFormatHintPropertyOptions = [
    'integer',
    'float',
    'percent',
    'points',
    'asset',
    'text',
    'timestamp',
];
exports.resultsTableColumnFormatHintPropertyDefinition = {
    view: { label: 'Results Table Column Format Hint' },
    constraints: [
        {
            name: 'options',
            argument: resultsTableColumnFormatHintPropertyOptions,
        },
    ],
    type: 'select',
    multiple: false,
    default: 'text',
    name: 'results-table-column-format-hint',
};
const isResultsTableColumnFormatHintProperty = (prop) => {
    return prop.name === exports.resultsTableColumnFormatHintPropertyDefinition.name;
};
exports.isResultsTableColumnFormatHintProperty = isResultsTableColumnFormatHintProperty;
const isResultsTableColumnFormatHintPropertyOption = (option) => {
    return resultsTableColumnFormatHintPropertyOptions.includes(option);
};
exports.isResultsTableColumnFormatHintPropertyOption = isResultsTableColumnFormatHintPropertyOption;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jb2x1bW4tZm9ybWF0LWhpbnQucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9yZXN1bHRzLXRhYmxlLWNvbHVtbi1mb3JtYXQtaGludC5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFNLDJDQUEyQyxHQUFHO0lBQ2xELFNBQVM7SUFDVCxPQUFPO0lBQ1AsU0FBUztJQUNULFFBQVE7SUFDUixPQUFPO0lBQ1AsTUFBTTtJQUNOLFdBQVc7Q0FDSCxDQUFBO0FBRUcsUUFBQSw4Q0FBOEMsR0FBRztJQUM1RCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsa0NBQWtDLEVBQUU7SUFDbkQsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsU0FBUztZQUNmLFFBQVEsRUFBRSwyQ0FBMkM7U0FDdEQ7S0FDRjtJQUNELElBQUksRUFBRSxRQUFRO0lBQ2QsUUFBUSxFQUFFLEtBQUs7SUFDZixPQUFPLEVBQUUsTUFBTTtJQUNmLElBQUksRUFBRSxrQ0FBa0M7Q0FDVCxDQUFBO0FBSTFCLE1BQU0sc0NBQXNDLEdBQUcsQ0FBQyxJQUFrQixFQUFnRCxFQUFFO0lBQ3pILE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxzREFBOEMsQ0FBQyxJQUFJLENBQUE7QUFDMUUsQ0FBQyxDQUFBO0FBRlksUUFBQSxzQ0FBc0MsMENBRWxEO0FBSU0sTUFBTSw0Q0FBNEMsR0FBRyxDQUFDLE1BQWMsRUFBd0QsRUFBRTtJQUNuSSxPQUFRLDJDQUFpRSxDQUFDLFFBQVEsQ0FBQyxNQUFNLENBQUMsQ0FBQTtBQUM1RixDQUFDLENBQUE7QUFGWSxRQUFBLDRDQUE0QyxnREFFeEQifQ==